// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"3948d45c","239":"b7e11851","455":"8bd6230b","488":"a49f8585"}[chunkId] + ".chunk.js";
};